// extracted by mini-css-extract-plugin
module.exports = {"win-card-box":"gB","winCardBox":"gB","win-card-btn-detail":"gC","winCardBtnDetail":"gC","win-card-dec":"gD","winCardDec":"gD","win-card-name":"gE","winCardName":"gE"};